<template>
  <div>
    <div
      class="racing-tool-back"
      :class=" hasPerms(item.authorityFlag) ? '' : 'no-permission'"
      @click="racingToolClicked(item)"
    >
      <div class="racing-tool-leftimg" :class="'coloricon' + item.menuTag">
        <i class="icon iconfont" :class="item.icon"></i>
      </div>
      <div class="racing-tool-right">
        <div>{{ item.rightTitle }}</div>
        <div class="racing-tool-desc">{{ item.rightDesc }}</div>
      </div>
    </div>
  </div>
</template>
<script>
import { hasPermission } from '@/permission/index.js'

export default {
  props: {
    item: {
      type: Object
    },
    index: {
      type: Number
    }
  },
  data () {
    return {

    }
  },
  methods: {
    racingToolClicked (item) {
      // console.log(item)
      if (!this.hasPerms(item.authorityFlag)) {
        return this.$message.warning('暂无操作权限')
      }
      if (item.showPop) {
        this.$emit('showPop', item)
        return
      }
      if (item.path) {
        this.$router.push(
          {
            path: item.path
          }
        )
      }
    },
    hasPerms: function (flag) {
      // 根据权限标识和外部指示状态进行权限判断
      return hasPermission(flag) // & !this.disabled
    }
  }
}
</script>
